module.exports = __webpack_public_path__ + "assets/images/ciq_bg-7b8ad1113a38104a764988c531e0b947.jpg";